import React, { useState, useEffect, useRef, useContext } from "react";
import Icon from "components/Icon";
import Uploadfile from "../../../components/uploadFiles";
import AddPromptModal from "components/PromptModal";
import { PromptsContext } from "context/promptsContext";
import { useUsersContext } from "context/usersContext";
import "regenerator-runtime/runtime";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Toast from "components/Toast";
import CommonModal from "components/AddUserModal/DumpModal";

const ChatInput = ({
  newMessage,
  setNewMessage,
  submitNewMessage,
  chatId,
  onFileSelect,
  selectedFiles,
  updatestateodfiles,
  setFileType,
  setSelectedFiles,
  asistantSelected,
  setAskAssistant,
  askAssistant,
  isAuto,
  messages,
  agentBuilder,
  openAgentBuilder,
}) => {
  const [micStatus, setMicStatus] = useState("unknown"); // 👉 "unknown" | "granted" | "denied"
  const textareaRef = useRef(null);
  const {
    addNewMessage,
    users,
    enableChat,
    SSO,
    updateMemory,
    createMemory,
    showToast,
    fetchMessageResponse,
    setLoadingStateslide,
    loadingStateslide,
    userTyping,
  } = useUsersContext();
  const [OpenErrorModal, setOpenErrorModal] = useState(false);

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const [recordingLoading, setRecordingLoading] = useState(false);
  const processedLen = useRef(0);
  const micStreamRef = useRef(null);
  const [isOpenAddPromptModal, setIsAddPromptModal] = useState(false);
  const { promptsData, getPrompts, hideloader } = useContext(PromptsContext);
  const [placeholdervalue, setplaceholdervalue] = useState(isAuto && (openAgentBuilder || asistantSelected?.assistant_name) ? `How can ${openAgentBuilder ? "Agent Builder" : asistantSelected?.assistant_name} help you today?` : `How can we help ${SSO?.business_name} today?`);

  useEffect(() => {
    setplaceholdervalue(!isAuto && (openAgentBuilder || asistantSelected?.assistant_name) ? `How can ${openAgentBuilder ? "Agent Builder" : asistantSelected?.assistant_name} help you today?` : `How can we help ${SSO?.business_name} today?`);
  }, [SSO, asistantSelected]);

  const [filesPopupOpen, setFilesPopupOpen] = useState(false);

  const autoResize = (el) => {
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  useEffect(() => {
    autoResize(textareaRef.current);
  }, [newMessage]);

  const validateAgentSelection = () => {
    if (!asistantSelected && !openAgentBuilder && !isAuto) {
      showToast("Please select an agent before chat", "error");
      setTimeout(() => {
        window.parent.postMessage({ action: "redirect-ai-agents" }, "*");
      }, 1000);
      return false;
    }
    return true;
  };

  const detectEnterPress = (e) => {

    if (e.key === "Enter" && !e.shiftKey) {
      if (!validateAgentSelection()) {
        e.preventDefault();
        return;
      }

      if (userTyping) { e.preventDefault(); return }

      if (selectedFiles.length >= 10) {
        const container = document.getElementById("errorofmaxfile");
        let div = document.createElement("div");
        div.style.display = "flex";
        div.style.justifyContent = "center";
        div.className = "file_upload_input";
        div.innerHTML = `
        <span style="position: absolute; top: 5px; right: 10px; cursor: pointer;" onclick="this.parentElement.remove()">&#10005;</span>
        <p style="padding: 15px; margin: 0px; color: red; text-align: center;">
            You can only upload 10 files at a time
        </p>
    `;
        container.appendChild(div);

        // Automatically remove the div after 5 seconds
        setTimeout(() => {
          div.remove();
        }, 5000);

        return true;
      }
      e.preventDefault();

      // e.target.style.height = "50px";
      updatestateodfiles([]);
      if (newMessage.trim()) {
        if (
          placeholdervalue ===
            !isAuto && (openAgentBuilder || asistantSelected?.assistant_name) ? `How can ${openAgentBuilder ? "Agent Builder" : asistantSelected?.assistant_name} help you today?` : `How can we help ${SSO?.business_name} today?`
        ) {
          submitNewMessage(newMessage, "savetodb", "notimage");
        } else {
          submitNewMessage(newMessage, "savetodb", "image");
        }
      }
    }
  };
  const activeConvo = users.find((user) => user.id === chatId);

  useEffect(() => {
    if (selectedFiles.length === 0) setFilesPopupOpen(false);
  }, [selectedFiles]);

  const justCloseIt = () => {
    setIsAddPromptModal(false);
  };

  const handleFileRemove = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!listening) return;
    if (transcript.length > processedLen.current) {
      const diff = transcript.slice(processedLen.current);
      setNewMessage((prev) => prev + diff);
      processedLen.current = transcript.length;
    }
  }, [transcript, listening, setNewMessage]);

  // if (!browserSupportsSpeechRecognition) {
  //   return <span>Your browser doesn’t support speech recognition.</span>;
  // }

  // if (micStatus === "denied") {
  //   return (
  //     <span>
  //       You blocked microphone access. Please enable it in the browser’s site-
  //       permissions panel and reload the page.
  //     </span>
  //   );
  // }

  // if (!browserSupportsSpeechRecognition) {
  //   return <span>Browser doesn't support speech recognition.</span>;
  // }

  const startListening = async () => {
    if (!browserSupportsSpeechRecognition) {
      setOpenErrorModal(true);
      return;
    }
    if (micStatus === "unknown") {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        micStreamRef.current = stream; // Save the stream reference
        setMicStatus("granted");
      } catch (err) {
        setMicStatus("denied");
        return;
      }
    }
    if (micStatus === "denied") {
      window.parent.postMessage({ type: "SHOW_MICROPHONE_ERROR" }, "*");
      return;
    }
    setRecordingLoading(true);
    SpeechRecognition.startListening({
      continuous: true,
      language: "en-US",
    });
  };

  const handleChange = (e) => {
    setNewMessage(e.target.value);

    if (e.target.value === "") {
      processedLen.current = 0;
      resetTranscript();
    }
  };

  const stopListening = () => {
    SpeechRecognition.stopListening();
    setRecordingLoading(false);
    resetTranscript();
    processedLen.current = 0;

    // Stop the original mic stream if present
    if (micStreamRef.current) {
      micStreamRef.current.getTracks().forEach((track) => track.stop());
      micStreamRef.current = null;
      setMicStatus("unknown");
    }
  };

  return (
    <div className="chat__input-wrapper">
      {/* ... other components ... */}

      <AddPromptModal
        isModalOpen={isOpenAddPromptModal}
        categories={promptsData?.prompt_category?.filter(
          (obj) => obj.type !== "super-admin"
        )}
        subCategories={promptsData?.prompt_sub_category?.filter(
          (obj) => obj.type !== "super-admin"
        )}
        justCloseIt={justCloseIt}
        getUpdatePromptsData={getPrompts}
      />

      {/* <div className="position-relative text-area" style={{ marginBottom: inputHeight }}></div> */}
      <div
        style={{
          background: "white",
          width: "100%",
          height: "fit-content",
          position: "relative",
          border: "1px solid #D9D9D9",
          borderRadius: "25px",
          paddingInline: "15px",
        }}
      >
        <textarea
          ref={textareaRef}
          className="v3chat__input"
          placeholder={placeholdervalue}
          value={newMessage}
          onChange={handleChange}
          onKeyDown={detectEnterPress}
          style={{
            overflowY: "auto",
            overflowX: "hidden", // Prevent horizontal scrolling
            resize: "none", // Prevent manual resizing
            width: "100%",
            maxHeight: "253px",
            minHeight: "108px",
            paddingTop: "35px",
            paddingLeft: "24px",
            paddingRight: "24px",
            border: "none",
            borderRadius: "25px 25px 0px 0px",
            outline: "none",
            fontFamily: "Inter",
          }}
          rows={1} // Start with a single row
          disabled={
            !isAuto && asistantSelected === undefined && !SSO?.openAgentBuilder
          }
        />

        <div className="ChatInput__buttons">
          <div
            style={{
              display: "flex",
              gap: "6px",
              alignItems: "center",
              paddingBottom: "20px",
            }}
          >
            <button
              className="hover-text-ai-agent"
              style={{
                outline: "none",
                position: "relative",
                border: "1px solid #D9D9D9",
                width: "36px",
                height: "36px",
                borderRadius: "5px",
              }}
              onClick={() => {
                window.parent.postMessage({ type: "GO_TO_AI_AGENT" }, "*");
              }}
            >
              <Icon id="aichatIconInput" />

              <span className="tooltip-text-ai-agent">
                {"Select an AI Agent"}
              </span>
            </button>

            <Uploadfile
              classname="filecogChatBtn"
              setSelectedFiles={setSelectedFiles}
              chatId={chatId}
              onFileSelect={onFileSelect}
              setFileType={setFileType}
            />

            {selectedFiles.length > 0 && (
              <button
                style={{
                  position: "relative",
                  fontSize: "12px",
                  color: "#757575",
                  outline: "none",
                }}
                onClick={() => setFilesPopupOpen((prev) => !prev)} // ⬅️ add this
              >
                {/* popup */}
                <div
                  id="errorofmaxfile"
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "0px",
                    zIndex: 9999,
                    display: filesPopupOpen ? "block" : "none", // ⬅️ hide / show
                  }}
                >
                  {selectedFiles?.map((file, index) => {
                    const fileName = file.name.split("/").pop();
                    const isFirst = index === 0;
                    const isLast = index === selectedFiles.length - 1;

                    const borderRadiusStyle = {
                      borderRadius: `${isFirst ? "5px" : "0px"} ${isFirst ? "5px" : "0px"
                        } ${isLast ? "5px" : "0px"} ${isLast ? "5px" : "0px"}`,
                      width: "242px",
                    };

                    return (
                      <div
                        key={index}
                        className="file_upload_input position-relative"
                        style={borderRadiusStyle}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            <Icon id="filePdf" />
                          </span>
                          <p style={{ padding: "15px", margin: "0px" }}>
                            {fileName.length > 10
                              ? `${fileName.slice(0, 10)}...`
                              : fileName}
                          </p>
                        </div>

                        <span
                          style={{ cursor: "pointer", marginLeft: "auto" }}
                          onClick={() => handleFileRemove(index)}
                        >
                          <Icon id="delete" />
                        </span>
                      </div>
                    );
                  })}
                </div>
                {selectedFiles.length} attached files{" "}
                <Icon id="upArrow12" color="#757575" />
              </button>
            )}
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              paddingBottom: "20px",
            }}
          >
            {userTyping || recordingLoading ? (
              <button
                onClick={() => {
                  stopListening();
                }}
              >
                <Icon id="chatContinuous" />
              </button>
            ) : (
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <button
                  onClick={() => {
                    startListening();
                  }}
                >
                  <Icon id="microphone" style={{ color: "#757575" }} />
                </button>

                <button
                  aria-label="Send message"
                  onClick={() => {
                    if (!newMessage.trim()) return; // Prevent sending empty or space-only messages
                    if (!validateAgentSelection()) return; // Validate agent selection
                    if (userTyping) return;
                    submitNewMessage(
                      newMessage,
                      "savetodb",
                      placeholdervalue ===
                        "What can your AI help you with next?"
                        ? "notimage"
                        : "image",
                      resetTranscript()
                    );
                  }}
                  className="sendChatBtn"
                >
                  <Icon id="sendChatInput" className="chat__input-icon" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <CommonModal
        isOpen={OpenErrorModal}
        onClose={() => setOpenErrorModal(false)}
        title=""
        showAlert={false}
      >
        <p style={{ color: "red", fontSize: "18px", fontWeight: "bold" }}>
          Your browser doesn’t support speech recognition.
        </p>
      </CommonModal>
    </div>
  );
};

export default ChatInput;
